import { MeshStandardMaterial } from 'three';

// Aluminum materials matching the real Go Rampe products.
// Reference: renders in Conception_Rampe/Dessin industriel/*.png
// All surfaces are anodized aluminum silver-grey.
export const MATERIALS = {
  // Structural aluminum (frames, posts, handrails) — neutral aluminium grey (ADJ-10)
  aluminumBrushed: new MeshStandardMaterial({
    color: 0xb0b0b0,
    metalness: 0.85,
    roughness: 0.65,
    envMapIntensity: 1.0,
  }),
  // Floor MAILLES — perforated/diamond mesh, slightly darker grey (ADJ-10)
  aluminumPerforated: new MeshStandardMaterial({
    color: 0xa0a0a0,
    metalness: 0.55,
    roughness: 0.65,
    transparent: false,
  }),
  // Rail/structural dark anodized steel
  steelAnodized: new MeshStandardMaterial({
    color: 0x1f2937,
    metalness: 0.9,
    roughness: 0.18,
  }),
  // Stainless steel hardware
  steelStainless: new MeshStandardMaterial({
    color: 0xd1d5db,
    metalness: 0.95,
    roughness: 0.12,
  }),
  // R1 Bug 4: Aluminum rivet (QRAL) — clear/bright finish.
  // Previously rivets rendered with steelAnodized (#1f2937, dark blue-grey)
  // which was visually wrong for ALU rivets.
  aluminumRivet: new MeshStandardMaterial({
    color: 0xc0c0c0,
    metalness: 0.92,
    roughness: 0.3,
    envMapIntensity: 1.0,
  }),
  // R1 Bug 4: Stainless steel rivet (QRSS) — very bright/polished finish.
  stainlessSteel: new MeshStandardMaterial({
    color: 0xd1d5db,
    metalness: 0.98,
    roughness: 0.15,
    envMapIntensity: 1.0,
  }),
};

export type MaterialKey = keyof typeof MATERIALS;

/**
 * Pick the right material for a hardware SKU prefix.
 *   QRAL → aluminumRivet (bright)
 *   QRSS → stainlessSteel (very bright)
 *   anything else → steelAnodized (legacy default)
 */
export function materialForHardwareSku(sku: string): MeshStandardMaterial {
  if (sku.startsWith('QRAL')) return MATERIALS.aluminumRivet;
  if (sku.startsWith('QRSS')) return MATERIALS.stainlessSteel;
  return MATERIALS.steelAnodized;
}
